import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { SkeletonBox } from '../../SkeletonBox/SkeletonBox.es.js';
import { useNotificationListProviderContext } from '../NotificationList.Context/NotificationList.Context.es.js';

const Title = ({ className, children })=>{
    const { loading } = useNotificationListProviderContext();
    return jsx("p", {
        className: classNames('cb-notification-list-item-title', className),
        children: jsx(SkeletonBox, {
            className: "loading",
            loading: loading,
            children: children
        })
    });
};
Title.displayName = 'NotificationList.Item.Title';

export { Title };
//# sourceMappingURL=NotificationList.Item.Title.es.js.map
